var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Globacom_Limited_Logo_1_",
    "data-name": "Globacom Limited Logo (1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.222,
    height: 41.222,
    viewBox: "0 0 41.222 41.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.48,
    y1: 0.088,
    x2: 0.545,
    y2: 0.83,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3e7c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5fbb46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 23.877,
    y1: -4.448,
    x2: 23.877,
    y2: -4.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.525,
    cy: 0.526,
    fy: 0.20531229674816132,
    r: 0.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.592,
    cy: 0.326,
    fx: 0.6458677649497986,
    fy: 0.9391846060752869,
    r: 0.616,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 17.672,
    cy: 17.672,
    rx: 17.672,
    ry: 17.672,
    transform: "translate(2.917 2.997)",
    fill: "#50b651"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M132.453,274.219a17.726,17.726,0,1,1-35.453,0c0-4.331.121-4.975,1.826-7.441a5.969,5.969,0,0,0,1.954,4.442c1.27,1.03,2.6.286,5.021-.831,2.624-1.21,4.757-1.99,6.422-1.784,2.507.311,10.235,4.951,14.267,4.027,3.222-.737,2.882-8.333,2.882-8.333C132.891,267.736,132.453,270.058,132.453,274.219Z",
    transform: "translate(-94.246 -253.599)",
    fillRule: "evenodd",
    opacity: 0.663,
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M673,275.768q9.617-9.046,3.2-20.727.033.024.794-2.741a16.474,16.474,0,0,1,3.633,10.214Q680.623,270.384,673,275.768Z",
    transform: "translate(-644.912 -242.127)",
    fillRule: "evenodd",
    opacity: 0.586,
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M468.76,116.22c-3.095-1.713-6.645-5.158-6.173-5.881s6.6-.6,9.693,1.114,5.729,6.85,5.258,7.574S471.854,117.932,468.76,116.22Z",
    transform: "translate(-443.712 -106.01)",
    fillRule: "evenodd",
    opacity: 0.744,
    fill: "url(#radial-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M564.109,382.062a4.783,4.783,0,1,1,4.649-4.781A4.716,4.716,0,0,1,564.109,382.062Zm.033-1.517a3.286,3.286,0,1,0-2.9-3.264A3.1,3.1,0,0,0,564.142,380.545Z",
    transform: "translate(-536.366 -357.04)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M447.08,284.98h3.35v13.358h-1.839V286.445H447.08Z",
    transform: "translate(-428.928 -273.369)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M240.905,375.262h1.739v11.155a3.333,3.333,0,0,1-2.111,2.531,8.391,8.391,0,0,1-2.727.384v-1.11a4.673,4.673,0,0,0,2.625-.865,2.608,2.608,0,0,0,.475-1.234v-3.277a3.351,3.351,0,0,1-4.592,1.961,4.467,4.467,0,0,1-1.914-2.5,7.537,7.537,0,0,1-.366-2.365,5.666,5.666,0,0,1,.622-2.451,4.685,4.685,0,0,1,2.306-2.027,9.667,9.667,0,0,1,3.013-.2v1.1a4.853,4.853,0,0,0-2.04.11c-.405.22-1.32.491-1.621,2.484s.009,3.624.965,4.134a1.9,1.9,0,0,0,1.443.2,3.462,3.462,0,0,0,2.072-2.457Q240.905,379.547,240.905,375.262Z",
    transform: "translate(-225.25 -359.666)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M141.754,180.731A17.406,17.406,0,1,1,114.9,162.8a16.847,16.847,0,1,0,26.855,17.931Z",
    transform: "translate(-104.103 -156.563)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M55,21A20.611,20.611,0,1,0,75.612,41.611,20.611,20.611,0,0,0,55,21Zm0,38.015a17.385,17.385,0,1,1,17.04-13.847A17.4,17.4,0,0,1,55,59.015Z",
    transform: "translate(-34.39 -21)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/Glo.b7555f152498576d1879075dfad285ae.svg";
export { ForwardRef as ReactComponent };